import RadioGroup from '@nib-components/radio-group';
import React from 'react';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { BlueMedicare, GreenMedicare, NoMedicare, YellowMedicare } from './icons';
import MedicareOption from './options';
const defaultLabel = 'What is the type of your Medicare card?';
const defaultHelpText = 'We use this information to show you relevant health covers';
const MedicareRadioGroup = _ref => {
  let {
    label = defaultLabel,
    help = defaultHelpText,
    inline = false,
    required,
    ...otherProps
  } = _ref;
  return React.createElement(BaseFormField, {
    label: label,
    help: help,
    ...otherProps,
    required: required,
    inline: inline
  }, React.createElement(RadioGroup, {
    options: {
      Green: React.createElement(MedicareOption, {
        Icon: GreenMedicare,
        label: "Australian resident (green)"
      }),
      Yellow: React.createElement(MedicareOption, {
        Icon: YellowMedicare,
        label: "Reciprocal Health Care Agreement (yellow)"
      }),
      Blue: React.createElement(MedicareOption, {
        Icon: BlueMedicare,
        label: "Interim Medicare card (blue)"
      }),
      None: React.createElement(MedicareOption, {
        Icon: NoMedicare,
        label: "No Medicare card"
      })
    },
    inline: false
  }));
};
const MedicareRadioGroupWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(MedicareRadioGroup, {
  ...props
}));
export default MedicareRadioGroupWithFunnel;